/**
 * 获取界面搜索数据
 * @param {*} flag 
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "exam":
            // 我的考试
            data = [{
                title: "状态",
                type: "select",
                value: "",
                key: "status",
                options: [
                    { label: "全部", value: "0" },
                    { label: "已发布", value: "1" },
                    { label: "已归档", value: "2" },
                    { label: "待批阅", value: "3" },
                ]
            }, {
                title: "考试时间",
                type: "time-range",
                value: [],
                key: "time"
            }, ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取搜索界面旁边的按钮
 * @param {*} flag 
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "exam":
            // 我的考试
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取表格表头数据
 */
export function getQuestionTableMenu() {
    let data = [
        { name: "考试主题", key: "name", isStar: false },
        { name: "考试时间", key: "time", isStar: false },
        { name: "状态", key: "status", isStar: false },
        { name: "专业", key: "professional", isStar: false },
        { name: "试卷", key: "testParperName", isStar: false },
        { name: "考试部门", key: "department", isStar: false },
        { name: "参考人数", key: "personNum", isStar: false },
        { name: "得分", key: "grade", isStar: false },
        { name: "提交时间", key: "subTime", isStar: false },
    ]
    return data
}
/**
 * 获取表格按钮操作
 * @param {*} flag 
 */
export function getTableBUttonList(flag) {
    let data = []
    switch (flag) {
        case "exam":
            // 我的考试
            data = [
                { text: "查看", active: "show_exam" },
            ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取考试界面模拟数据
 */
export function getinitExamData() {
    return [{
        type: "0", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "1",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }, {
            index: "2",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "3",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }, {
            index: "4",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }, {
            index: "5",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }, {
            index: "6",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }, {
            index: "7",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: ""
        }]
    }, {
        type: "1", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "8",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "9",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "10",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "11",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "12",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "13",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "14",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }]
    }, {
        type: "2", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "15",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "16",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "17",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, {
            index: "18",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: ""
        }, ]
    }, {
        type: "3", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "19",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "20",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "21",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "22",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 4,
            points: "2",
            answer: "",
            grade: ""
        }, ]
    }, {
        type: "4", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "23",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "24",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "25",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, {
            index: "26",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: ""
        }, ]
    }, ]
}

/**
 * 小写数字转大写数字
 */
export function transitionNumToText(num) {
    let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
    return text[num];
}